export const NON_HIDABLE_COLUMNS = ['fullName', 'name'];
